// Vistas top-level del módulo projects.
// El registry declara dos tabs: 'list' (timeline) y 'time-entries'.

import { useState } from 'react';

import { ProjectDetail } from './components/ProjectDetail';
import { ProjectList } from './components/ProjectList';
import { TimeEntries } from './components/TimeEntries';

export function ProjectsListView() {
  const [selected, setSelected] = useState<string | null>(null);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 p-4">
      <div className="space-y-3">
        <h1 className="text-xl font-semibold">Proyectos</h1>
        <p className="text-xs text-neutral-500">
          Ejecución de quotes aceptados → milestones → invoice automático.
        </p>
        <ProjectList selectedId={selected} onSelect={setSelected} />
      </div>
      <div className="space-y-3">
        <h2 className="text-sm font-semibold text-neutral-500">Detalle</h2>
        <ProjectDetail projectId={selected} />
      </div>
    </div>
  );
}

export function ProjectsTimeEntriesView() {
  const [selected, setSelected] = useState<string | null>(null);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 p-4">
      <div className="space-y-3">
        <h1 className="text-xl font-semibold">Horas por proyecto</h1>
        <ProjectList selectedId={selected} onSelect={setSelected} />
      </div>
      <div className="space-y-3">
        <h2 className="text-sm font-semibold text-neutral-500">
          Time entries
        </h2>
        <TimeEntries projectId={selected} />
      </div>
    </div>
  );
}
